export default __webpack_public_path__ + "static/LA_NOLA_1025_ZSMITH-2025-04-16-097141920px-86b7566d7fe885da7892961cdab04264.jpg";